// 低版本兼容
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueLazyload from 'vue-lazyload'
// --------- style
import './styles/normalize.css'
import '@bilibili/fe-quick-share/dist/share.css'
// --------- extends register
// import './register'
// --------- component

Vue.use(VueLazyload)
Vue.config.productionTip = false

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app')
